var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_2068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.2943 7.78235H21.27C18.124 7.78235 15.5645 10.3419 15.5645 13.4918C15.5645 16.6378 18.124 19.1974 21.27 19.1974H56.2942C59.4402 19.1974 61.9998 16.6378 61.9998 13.4918C61.9999 10.3418 59.4403 7.78235 56.2943 7.78235V7.78235Z",
    fill: "#817BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70763 7.78235C2.56053 7.78235 0 10.3428 0 13.4899C0 16.637 2.56053 19.1974 5.70763 19.1974C8.85474 19.1974 11.4151 16.637 11.4151 13.4899C11.4151 10.3428 8.85474 7.78235 5.70763 7.78235V7.78235Z",
    fill: "#D6D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70763 25.2925C2.56053 25.2925 0 27.8529 0 31C0 34.1471 2.56053 36.7075 5.70763 36.7075C8.85474 36.7075 11.4151 34.1471 11.4151 31C11.4151 27.8529 8.85474 25.2925 5.70763 25.2925V25.2925Z",
    fill: "#D6D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70763 42.8026C2.56053 42.8026 0 45.363 0 48.5102C0 51.6573 2.56053 54.2177 5.70763 54.2177C8.85474 54.2177 11.4151 51.6573 11.4151 48.5102C11.4151 45.363 8.85474 42.8026 5.70763 42.8026V42.8026Z",
    fill: "#D6D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.415 13.4899C11.415 10.3428 8.85462 7.78235 5.70752 7.78235V19.1975C8.85462 19.1974 11.415 16.637 11.415 13.4899V13.4899Z",
    fill: "#817BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.415 31C11.415 27.8529 8.85462 25.2925 5.70752 25.2925V36.7077C8.85462 36.7075 11.415 34.1471 11.415 31Z",
    fill: "#817BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.415 48.5102C11.415 45.3631 8.85462 42.8027 5.70752 42.8027V54.2178C8.85462 54.2177 11.415 51.6573 11.415 48.5102Z",
    fill: "#817BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2943 7.78235H38.7822V19.1975H56.2943C59.4403 19.1975 61.9999 16.6379 61.9999 13.4919C61.9999 10.3418 59.4403 7.78235 56.2943 7.78235V7.78235Z",
    fill: "#ACA8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2943 25.2925H21.27C18.124 25.2925 15.5645 27.852 15.5645 31.0019C15.5645 34.1479 18.124 36.7075 21.27 36.7075H56.2942C59.4402 36.7075 61.9998 34.1479 61.9998 31.0019C61.9999 27.8519 59.4403 25.2925 56.2943 25.2925V25.2925Z",
    fill: "#817BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2943 25.2925H38.7822V36.7076H56.2943C59.4403 36.7076 61.9999 34.1481 61.9999 31.0021C61.9999 27.8519 59.4403 25.2925 56.2943 25.2925V25.2925Z",
    fill: "#ACA8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2943 42.8026H21.27C18.124 42.8026 15.5645 45.3622 15.5645 48.5121C15.5645 51.6581 18.124 54.2177 21.27 54.2177H56.2942C59.4402 54.2177 61.9998 51.6581 61.9998 48.5121C61.9999 45.3622 59.4403 42.8026 56.2943 42.8026V42.8026Z",
    fill: "#817BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2943 42.8026H38.7822V54.2178H56.2943C59.4403 54.2178 61.9999 51.6582 61.9999 48.5122C61.9999 45.3622 59.4403 42.8026 56.2943 42.8026V42.8026Z",
    fill: "#ACA8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_2068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.980d582b28861f1f605de7f0d0b08eca.svg";
export { ForwardRef as ReactComponent };